<template>
  <div>
    <b-modal
      id="moveDayAttractions"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg"
    >
      <section class="text-center" v-if="isRideDataValid">
        <b-row>
          <b-col cols="12" class="py-2">
            <h3 class="font-weight-medium card-title">{{ t('moveDayAttractionsTitle') }}</h3>
          </b-col>
          <b-col cols="12" class="py-2">
            <b-form-group :label="t('moveDayAttractionsTargetDayLabel')" label-for="target-day-select">
              <datepicker
                class="input-uniform"
                v-model="updateAttractionDate"
                :disabled-dates="getCoulenderDates"
              ></datepicker>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="py-2 d-flex flex-column flex-md-row justify-content-center gap-2">
            <b-btn
              pill
              variant="warning"
              class="px-5 py-2 text-white"
              @click="moveAttractions"
            >
              {{ t('moveDayAttractionsMoveButton') }}
            </b-btn>
            <b-btn
              pill
              variant="secondary"
              class="px-5 py-2 text-white"
              @click="closePopup"
            >
              {{ t('cancel') }}
            </b-btn>
          </b-col>
        </b-row>
      </section>
      <section v-else class="text-center py-4">
        <p class="text-muted">{{ t('moveDayAttractionsLoadingRideData') }}</p>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { translationMixin } from "@/mixins/translationMixin";

export default {
  props: ["value"],
  mixins: [translationMixin],
  
  components: {
    Datepicker,
  },
  
  computed: {
    ...mapGetters([
      "allRide", 
      "inerModalParameters",
      "newAttractionDateTime",
    ]),
    
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    
    isRideDataValid() {
      return this.allRide && 
             this.allRide.ride && 
             this.allRide.ride.start_date && 
             this.allRide.ride.end_date;
    },
    
    updateAttractionDate: {
      get() {
        return this.newAttractionDateTime;
      },
      set(value) {
        if (!value) return;
        
        const rideFirstDay = new Date(value);
        this.$store.commit(
          "setNewAttractionDate",
          moment(rideFirstDay).format("M/D/YYYY")
        );
      },
    },
    
    getCoulenderDates() {
      if (!this.isRideDataValid) {
        return {
          customPredictor: () => true // Disable all dates if ride data is invalid
        };
      }
      
      const startDate = moment(
        this.allRide.ride.start_date,
        "DD-MM-YYYY"
      ).toDate();
      const endDate = moment(
        this.allRide.ride.end_date,
        "DD-MM-YYYY"
      ).toDate();

      return {
        customPredictor(date) {
          return date < startDate || date > endDate;
        },
      };
    }
  },
  
  methods: {
    ...mapActions([
      "moveDayAttractions",
      "showModal",
      "showModalWithParameters",
    ]),
    
    async moveAttractions() {
      if (!this.isRideDataValid || !this.inerModalParameters?.dayIndex) {
        this.$bvToast.toast(this.t('moveDayAttractionsInvalidData'), {
          title: this.t('error'),
          variant: 'danger'
        });
        return;
      }

      try {
        await this.moveDayAttractions({ 
          dayIndex: this.inerModalParameters.dayIndex 
        });

        this.showModalWithParameters({
          errorNumber: "day_activities_moved_successfully",
          type: "textConverter",
        });
      } catch (error) {
        console.error('Failed to move attractions:', error);
        this.$bvToast.toast(this.t('moveDayAttractionsFailed'), {
          title: this.t('error'),
          variant: 'danger'
        });
      }
    },
    
    closePopup() {
      this.showModal("");
    },
  },
};
</script>

<style scoped>
.elementstyle {
  text-align: -webkit-center;
}

.input-uniform {
  width: 100%;
  max-width: 300px;
  font-size: 1.6rem;
  padding: 0.8rem 1rem;
  direction: ltr;
  margin-bottom: 1.5rem;
}

.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}
</style> 